// extracted by mini-css-extract-plugin
module.exports = {"note":"style_note__3uJBI","checkboxNote":"style_checkboxNote__14Pnl","header":"style_header__33m1I"};